import { Grid } from "@mui/material";
import dayjs from "dayjs";
import LabeledValue from "@/components/LabeledValue";
import {
  CHECK_IN_LABEL,
  CHECK_IN_SESSION_TIME_FORMAT,
} from "../group-visit-constant";
import { CheckInSession } from "../group-visit-types";
import DetailCard from "./DetailCard";

export type CheckInSummaryCardProps = {
  session: CheckInSession;
};

/**
 * Group, time and therapist for the session being checked in.
 *
 * @author Rajkumar Rathod
 */
const CheckInSummaryCard = ({ session }: CheckInSummaryCardProps) => (
  <DetailCard>
    <Grid container spacing={2}>
      <Grid
        size={{
          xs: 12,
          sm: 4,
        }}
      >
        <LabeledValue
          label={CHECK_IN_LABEL.summaryGroup}
          value={session.groupName}
        />
      </Grid>

      <Grid
        size={{
          xs: 12,
          sm: 4,
        }}
      >
        <LabeledValue
          label={CHECK_IN_LABEL.summaryWhen}
          value={
            session.startsAt
              ? dayjs(session.startsAt).format(CHECK_IN_SESSION_TIME_FORMAT)
              : undefined
          }
        />
      </Grid>

      <Grid
        size={{
          xs: 12,
          sm: 4,
        }}
      >
        <LabeledValue
          label={CHECK_IN_LABEL.summaryTherapist}
          value={session.therapistName}
        />
      </Grid>
    </Grid>
  </DetailCard>
);

export default CheckInSummaryCard;
